module.exports = __webpack_public_path__ + "static/oic_modal.1497826c.png";